import { RemixBrowser, useLocation, useMatches } from '@remix-run/react';
import * as Sentry from '@sentry/remix';
import { StrictMode, startTransition, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';

Sentry.init({
    dsn: 'https://ca0e996ec3a16925fb86518676504c7e@o4506638974582784.ingest.us.sentry.io/4507745295925248',
    integrations: [
        Sentry.browserTracingIntegration({
            useEffect,
            useLocation,
            useMatches,
        }),
        Sentry.replayIntegration(),
    ],
    replaysOnErrorSampleRate: 1,
    replaysSessionSampleRate: 0.1,

    tracesSampleRate: 0.1,

    tracesSampler: (samplingContext) => {
        // Check if the request URL is `/health` and ignore those transactions
        if (
            samplingContext.request &&
            samplingContext.request.url?.includes('/health')
        ) {
            return 0; // Drop the transaction
        }
        return 1.0; // Otherwise, sample normally
    },
});

startTransition(() => {
    hydrateRoot(
        document,
        <StrictMode>
            <RemixBrowser />
        </StrictMode>
    );
});
